import React from "react";

import Button from "./Button";
import { useDispatch } from "react-redux";
import { openModal } from "state/slices/modals";
import { TrashIcon } from "@heroicons/react/outline";

const DeleteButtonWithConfirmation = React.forwardRef(
  (
    {
      row,
      btnClasses,
      confirmationModalName,
      btnLabel = "Delete",
      ...restProps
    },
    ref
  ) => {
    const dispatch = useDispatch();

    return (
      <Button
        {...restProps}
        ref={ref}
        onClick={() =>
          dispatch(
            openModal({ modalName: confirmationModalName, modalRow: row })
          )
        }
        className={btnClasses}
      >
        <TrashIcon className="w-4 h-4 mr-1" />
        {btnLabel}
      </Button>
    );
  }
);

DeleteButtonWithConfirmation.displayName = "DeleteButtonWithConfirmation";

export default DeleteButtonWithConfirmation;
